export const header_components_mobile = [
  {
    type: "HeaderDropdownMobile",
    label: "Aufträge finden",
    link: "/ausschreibungsdienste",
    dropdown_menu_items: [
      {
        type: "Link",
        link: "/ausschreibungsdienste/ausschreibungen",
        label: "Ausschreibungen",
      },
      {
        type: "Link",
        link: "/ausschreibungsdienste/preise",
        label: "Preise",
      },
      {
        type: "Link",
        link: "/ausschreibungsdienste/support",
        label: "Support",
      },
      {
        type: "Link",
        link: "/ausschreibungsdienste/teilnehmen",
        label: "An Vergabe teilnehmen",
      },
      {
        type: "LinkButtonInternal",
        link: `${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}?productId=${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`,
        label: "Kostenfrei testen",
      },
    ],
  },
  {
    type: "HeaderDropdownMobile",
    label: "Aufträge vergeben",
    link: "/evergabe",
    dropdown_menu_items: [
      {
        type: "Link",
        link: "/evergabe/produkt",
        label: "Produkt",
      },
      {
        type: "Link",
        link: "/evergabe/preise",
        label: "Preise",
      },
      {
        type: "Link",
        link: "/evergabe/verfahrensabwicklung",
        label: "Dienstleistungen",
      },
      {
        type: "Link",
        link: "/evergabe/umsteigen",
        label: "Umsteigen",
      },
      {
        type: "Link",
        link: "/evergabe/support",
        label: "Support",
      },
      {
        type: "Link",
        link: "/evergabe/veranstaltungen-und-seminare",
        label: "Seminare",
      },
      {
        type: "Link",
        link: "/evergabe/hilfe",
        label: "Hilfe",
      },
      {
        type: "LinkButtonExternal",
        link: "/evergabe/demo-buchen",
        label: "Demo anfordern",
      },
    ],
  },

  {
    type: "HeaderDropdownMobile",
    label: "Vergabe-Wissen",
    link: "/vergabe-wissen",
    dropdown_menu_items: [
      {
        type: "Link",
        link: "/vergabe-wissen/news",
        label: "News",
      },
      {
        type: "Link",
        link: "/vergabe-wissen/lexikon",
        label: "Lexikon",
      },
      {
        type: "Link",
        link: "/vergabe-wissen/blog",
        label: "Blog",
      },
      {
        type: "Link",
        link: "/vergabe-wissen/quiz",
        label: "Quiz",
      },
    ],
  },

  {
    type: "HeaderDropdownMobile",
    label: "Fachzeitschriften",
    link: "/fachzeitschriften",
    dropdown_menu_items: [
      {
        type: "Link",
        link: "/fachzeitschriften/baumagazin",
        label: "B_I baumagazin",
      },
      {
        type: "Link",
        link: "/fachzeitschriften/umweltbau",
        label: "B_I umweltbau",
      },
      {
        type: "Link",
        link: "/fachzeitschriften/galabau",
        label: "B_I galabau",
      },
    ],
  },
  {
    type: "HeaderLinkMobile",
    label: "Stellenanzeigen",
    link: "/fachzeitschriften/jobs-in-der-bauwirtschaft",
  },
  {
    type: "HeaderDropdownMobile",
    label: "Über Uns",
    link: "/ueber-uns",
    dropdown_menu_items: [
      {
        type: "Link",
        link: "/ueber-uns/redaktion",
        label: "Redaktion",
      },
      {
        type: "Link",
        link: "/ueber-uns/team",
        label: "Team",
      },
      {
        type: "Link",
        link: "/ueber-uns/kontakt",
        label: "Kontakt",
      },
      {
        type: "Link",
        link: "/ueber-uns/media",
        label: "Media",
      },
      {
        type: "Link",
        link: "/newsletter-anmeldung",
        label: "Newsletter",
      },
      {
        type: "Link",
        link: "/ueber-uns/presse",
        label: "Presse",
      },
    ],
  },
  {
    type: "HeaderDropdownButtonMobile",
    label: "Login",
    link: "/login",
    dropdown_menu_items: [
      {
        type: "Link",
        href: "https://login.bi-medien.de/Account/Login?culture=de",
        label: "Auftragnehmer",
      },
      {
        type: "Link",
        href: "https://evergabe.bi-medien.de",
        label: "Auftraggeber",
      },
    ],
  },
]
